// Client-side, in-memory cache for the Travel Files server-side grid.
//
// Why: clicking a row navigates to a different route, which UNMOUNTS the list.
// On "Back to list" the grid remounts and AG-Grid immediately re-runs the
// (often heavy) search query — a visible spinner every time. This cache lets a
// back-navigation serve the same page of results instantly, with no network
// call, while genuinely new searches/pages still hit the server.
//
// Scope & lifetime:
//  - Lives only in browser memory (NOT Redis/server). Survives in-app route
//    changes (the module stays loaded); cleared on full page reload.
//  - Kept until the NEXT search (cleared when the user runs a new search) or a
//    travel-file mutation — there's no time-based expiry. The cache is keyed by
//    the exact request, so back-navigation with the same search hits it.
//  - Explicitly cleared on any travel-file mutation (see clearTravelFilesQueryCache)
//    so edits show immediately on the next list view.

type CacheEntry = { rowData: any[]; rowCount: number };

const MAX_ENTRIES = 50; // safety cap against unbounded growth

const cache = new Map<string, CacheEntry>();

export function getCachedQuery(key: string): CacheEntry | null {
    return cache.get(key) || null;
}

export function setCachedQuery(key: string, rowData: any[], rowCount: number): void {
    if (cache.size >= MAX_ENTRIES) cache.clear();
    cache.set(key, { rowData, rowCount });
}

/** Drop all cached results — call after any travel-file mutation so the list
 *  reflects the change on the next view (no stale rows). */
export function clearTravelFilesQueryCache(): void {
    cache.clear();
}
